import { ReactElement } from "react";
import { Image } from "@xp-design/mobile";
import "./index.less";
import { processOssImage } from "@/utils/image";
import React from "react";

interface PropsRule {
  level?: number;
  className?: string;
  animatedImgClassName?: string;
  children?: ReactElement;
}
export const BG_DATA = {
  1: "https://s.xiaopeng.com/xp-charge/charge/charge-vip/v1_2.webp",
  2: "https://s.xiaopeng.com/xp-charge/charge/charge-vip/v2_2.webp",
  3: "https://s.xiaopeng.com/xp-charge/charge/charge-vip/v3_2.webp",
};

const renderImagePlaceholder = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        background: "rgba(0, 0, 0, 1)",
        position: "absolute",
        top: 0,
        zIndex: -2,
      }}
    ></div>
  );
};

const AnimatedBgWrapper = (props: PropsRule) => {
  const { level = "", className = "", children } = props;
  const returnWebpBg = React.useMemo(() => {
    return level && BG_DATA[level];
  }, [level]);
  console.log("levelInfolevelInfolevelInfo", returnWebpBg);
  return (
    <div className={`animated-bg-wrapper ${className}`}>
      {!!level && (
        <>
          <Image
            className={`animated-bg-wrapper-img`}
            src={returnWebpBg}
            alt=""
            fallback={null}
            placeholder={null}
            width={"100%"}
          />
          <div className="animated-bg-black"></div>
        </>
      )}
      <Image
        placeholder={renderImagePlaceholder()}
        className={`animated-bg-wrapper-img-holder`}
        src={processOssImage(
          "https://s.xiaopeng.com/xp-charge/charge/charge-vip/vip-header-bg-v2.png",
        )}
        oss
        alt=""
        width={"100%"}
        height={"100%"}
      />
      <div className="content">{children}</div>
    </div>
  );
};

export default AnimatedBgWrapper;
